import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PaymentDetails, PaymentResponse } from '../domain/registrator';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  endpoint: string = environment.api_url;

  constructor(private http: HttpClient, private messageService: MessageService) { }

  recordRegistrationPayment(paymentDetails: PaymentDetails): Observable<PaymentResponse> {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.http.post<PaymentResponse>(`${this.endpoint}/payment/registration`, JSON.stringify(paymentDetails), { headers });
  }

  sendPaymentReminder(registrationId: number): Observable<HttpResponse<void>> {
    return this.http.post<void>(`${this.endpoint}/payment/registration/${registrationId}/reminder`, {}, { observe: 'response' });
  }
}
